function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1912(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 29.74,
    height: 11.78,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.87,
    y: 5.89
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 11.78,
    width: 29.74,
    height: 33.32,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.956666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.87,
    y: 28.439999999999998
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 45.1,
    width: 29.74,
    height: 39.55,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.956666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.87,
    y: 64.875
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 84.65,
    width: 29.74,
    height: 45.31,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.9479999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.87,
    y: 107.305
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 129.96,
    width: 29.74,
    height: 63.21,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.9479999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.87,
    y: 161.565
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 193.17,
    width: 29.74,
    height: 66.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.9479999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.87,
    y: 226.535
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 259.9,
    width: 29.74,
    height: 67.49,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.87,
    y: 293.645
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 327.39,
    width: 29.74,
    height: 70.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.478333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.87,
    y: 362.445
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 397.5,
    width: 29.74,
    height: 73.4,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.9479999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.87,
    y: 434.2
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 470.9,
    width: 29.74,
    height: 74.82,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.248571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.87,
    y: 508.30999999999995
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 545.73,
    width: 29.74,
    height: 76.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.87,
    y: 584.11
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 622.49,
    width: 29.74,
    height: 77.51,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.956666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.87,
    y: 661.245
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.74,
    y: 0,
    width: 46.41,
    height: 52.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.94499999999999,
    y: 26.355
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.15,
    y: 0,
    width: 46.64,
    height: 52.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.773333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 99.47,
    y: 26.355
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122.79,
    y: 0,
    width: 47.37,
    height: 52.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.92125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 146.475,
    y: 26.355
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.15,
    y: 0,
    width: 47.43,
    height: 52.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.92875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.865,
    y: 26.355
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.58,
    y: 0,
    width: 48.37,
    height: 52.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.909999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.76500000000001,
    y: 26.355
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.95,
    y: 0,
    width: 49.13,
    height: 52.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.14125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 290.515,
    y: 26.355
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.08,
    y: 0,
    width: 51.06,
    height: 52.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.2942857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.61,
    y: 26.355
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.14,
    y: 0,
    width: 52.52,
    height: 52.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.252000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 392.4,
    y: 26.355
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 418.66,
    y: 0,
    width: 52.96,
    height: 52.71,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.58875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 445.14000000000004,
    y: 26.355
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 471.62,
    y: 0,
    width: 55.41,
    height: 52.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.58875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 499.325,
    y: 26.355
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 527.03,
    y: 0,
    width: 57.6,
    height: 52.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.58875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 555.8299999999999,
    y: 26.355
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 584.63,
    y: 0,
    width: 57.63,
    height: 52.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.785
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 613.445,
    y: 26.355
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642.26,
    y: 0,
    width: 57.74,
    height: 52.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.58875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.13,
    y: 26.355
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.74,
    y: 52.71,
    width: 58.01,
    height: 52.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.5442857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.745,
    y: 79.11500000000001
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.74,
    y: 105.51,
    width: 58.01,
    height: 59.67,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.801
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.745,
    y: 135.345
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.74,
    y: 165.18,
    width: 58.01,
    height: 62.4,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.25125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.745,
    y: 196.38
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.74,
    y: 227.58,
    width: 58.01,
    height: 62.91,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.602
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.745,
    y: 259.035
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.74,
    y: 290.48,
    width: 58.01,
    height: 63.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.801
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.745,
    y: 322.385
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.74,
    y: 354.29,
    width: 58.01,
    height: 65.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.287142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.745,
    y: 386.94
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.74,
    y: 419.59,
    width: 58.01,
    height: 67.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.668333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.745,
    y: 453.2
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.74,
    y: 486.82,
    width: 58.01,
    height: 69.05,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.287142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.745,
    y: 521.345
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.74,
    y: 555.87,
    width: 58.01,
    height: 71.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.445555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.745,
    y: 591.825
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.74,
    y: 627.78,
    width: 58.01,
    height: 72.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.25125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.745,
    y: 663.89
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.75,
    y: 52.71,
    width: 63.88,
    height: 66.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.646666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.69,
    y: 85.98
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.62,
    y: 52.71,
    width: 66.59,
    height: 66.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.04909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.91500000000002,
    y: 85.98
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.22,
    y: 52.71,
    width: 73.06,
    height: 66.54,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.3175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 254.75,
    y: 85.98
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.27,
    y: 52.71,
    width: 74.2,
    height: 66.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.090000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.37,
    y: 85.98
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365.47,
    y: 52.71,
    width: 81.71,
    height: 66.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.393333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 406.32500000000005,
    y: 85.98
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 447.19,
    y: 52.71,
    width: 82.2,
    height: 66.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.04909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 488.29,
    y: 85.98
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 529.39,
    y: 52.71,
    width: 84.63,
    height: 66.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.090000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 571.7049999999999,
    y: 85.98
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 614.01,
    y: 52.71,
    width: 85.99,
    height: 66.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.090000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 657.005,
    y: 85.98
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.75,
    y: 119.24,
    width: 73.27,
    height: 78.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.15875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.38499999999999,
    y: 158.57999999999998
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.75,
    y: 197.92,
    width: 73.27,
    height: 79.2,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.467142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.38499999999999,
    y: 237.51999999999998
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.75,
    y: 277.12,
    width: 73.27,
    height: 79.92,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.467142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.38499999999999,
    y: 317.08
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.75,
    y: 357.04,
    width: 73.27,
    height: 82.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.211666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.38499999999999,
    y: 398.15000000000003
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.75,
    y: 439.25,
    width: 73.27,
    height: 82.76,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.467142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.38499999999999,
    y: 480.63
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.75,
    y: 522.02,
    width: 73.27,
    height: 86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.15875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.38499999999999,
    y: 565.02
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.75,
    y: 608.02,
    width: 73.27,
    height: 91.98,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.327
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.38499999999999,
    y: 654.01
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.01,
    y: 119.24,
    width: 74.37,
    height: 99.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.395000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.195,
    y: 169.07
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.38,
    y: 119.24,
    width: 85.1,
    height: 99.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.51
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 277.93,
    y: 169.07
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.48,
    y: 119.24,
    width: 104.24,
    height: 99.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.61
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 372.6,
    y: 169.07
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424.72,
    y: 119.24,
    width: 133.15,
    height: 99.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.61
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 491.295,
    y: 169.07
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 557.87,
    y: 119.24,
    width: 142.13,
    height: 99.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.4575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 628.935,
    y: 169.07
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.01,
    y: 218.91,
    width: 159.16,
    height: 103.85,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.308333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 240.58999999999997,
    y: 270.835
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.01,
    y: 322.76,
    width: 159.16,
    height: 104.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.464545454545455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 240.58999999999997,
    y: 374.815
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.01,
    y: 426.87,
    width: 159.16,
    height: 108.15,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.025000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 240.58999999999997,
    y: 480.945
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.01,
    y: 535.02,
    width: 159.16,
    height: 164.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 39.79
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 240.58999999999997,
    y: 617.51
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.17,
    y: 218.91,
    width: 379.83,
    height: 198.72,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 39.744
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 510.08500000000004,
    y: 318.27
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.17,
    y: 417.63,
    width: 379.83,
    height: 282.37,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 35.29625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 510.08500000000004,
    y: 558.815
  }, "\n        New_York\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1912);
export default __webpack_public_path__ + "static/media/1912.24dc53f9757e2594c9af8dbbbd803f16.svg";
export { ForwardRef as ReactComponent };